import React from 'react'
import styled from 'styled-components'
import {
  Box,
  Card,
  Container,
  Hide,
  Divider,
  Flex,
  theme
} from 'pcln-design-system'
import { Gpt } from '@pcln/ad-unit'
import HeroImageParallax from '@/components/Heros/HeroImageParallax'
import StyledHeading from '@/components/StyledHeading'
import useContentfulSearchFormHeadlines from '@/hooks/useContentfulSearchFormHeadlines'
import useCityNameInFormHeadlineForSEMFlights from '@/hooks/useCityNameInFormHeadlineForSEMFlights'
import FlightsSearchForm from '../SearchForm/Form'
import FlightsContent from '../Content'
import ExpressDealBanner from '../ExpressDeal/ExpressDealBanner'
import { onSubmit } from '../SearchForm/utils'
import {
  PRIMARY_HEADING_FALLBACK,
  SECONDARY_HEADING_FALLBACK
} from '../constants'

const BlockFlex = styled(Box)`
  position: relative;
  z-index: 1;
  display: block;
  height: auto;
  ${theme.mediaQueries[3]} {
    display: flex;
  }
`

const HideFlexNone = styled(Hide)`
  flex: none;
  text-align: center;
  position: relative;
  margin: 16px;
  min-height: 100px;
  ${theme.mediaQueries[3]} {
    width: 300px;
    margin: 0 16px;
  }
`

const Desktop = () => {
  const searchForm = useContentfulSearchFormHeadlines('searchForm')
  const semPrepopHeadline = useCityNameInFormHeadlineForSEMFlights()
  const headingValue =
    semPrepopHeadline || searchForm?.headline || PRIMARY_HEADING_FALLBACK
  const subHeadingValue = searchForm?.subheadline || SECONDARY_HEADING_FALLBACK

  return (
    <Box data-testid="flights-desktop">
      <HeroImageParallax
        isScrollable
        gptId="div-gpt-ad-1510165335112-0"
        slot="/3102/priceline.dart/air_homepage_hero_image"
        mb={4}
      >
        <Container maxWidth={1280}>
          <BlockFlex
            mx={3}
            py={[3, null, null, null, 5]}
            alignItems="flex-start"
          >
            <Box width={1}>
              <Card
                borderWidth={0}
                color="background.lightest"
                borderRadius="2xl"
                boxShadowSize="xl"
              >
                <Box p={[3, 4]} width={1}>
                  <Flex flexDirection="column" mb={3}>
                    <StyledHeading
                      text={headingValue}
                      textStyle="heading2"
                      color="text.heading"
                      tag="h1"
                    />
                    <StyledHeading
                      color="text.light"
                      textStyle="subheading4"
                      text={subHeadingValue}
                      tag="h2"
                    />
                  </Flex>
                  <FlightsSearchForm onSubmit={onSubmit} />
                </Box>
                <Hide xs sm>
                  <Divider m={0} />
                  <Box
                    color="background.light"
                    borderRadius="2xl"
                    boxShadowSize="xl"
                    rounded="bottom"
                  >
                    <ExpressDealBanner />
                  </Box>
                </Hide>
              </Card>
            </Box>
            <HideFlexNone xs sm>
              <Gpt render={() => <div id="div-gpt-ad-1510165683878-0" />} />
            </HideFlexNone>
          </BlockFlex>
        </Container>
      </HeroImageParallax>
      <Hide xs sm color="background.lightest">
        <FlightsContent />
      </Hide>
    </Box>
  )
}

export default Desktop
